// extracted by mini-css-extract-plugin
module.exports = {"warp":"Schedule_warp__12trQ","groupTitle":"Schedule_groupTitle__2_og0","noMeetingTips":"Schedule_noMeetingTips__3wMLy","img":"Schedule_img__23ymT","text":"Schedule_text__bhGI-"};